import type { ApiResponse } from "@/api"

const getMimeTypeFromResponse = (
  data: ApiResponse<unknown>
) => {
  return new Map(Object.entries(data.headers)).get(
    "content-type"
  )
}

const getFileNameFromResponse = (
  data: ApiResponse<unknown>
) => {
  const dispositionHeader = new Map(
    Object.entries(data.headers)
  ).get("content-disposition")
  const filename = dispositionHeader
    ?.split(/;(.+)/)[1]
    .split(/=(.+)/)[1]
  return filename
}

export const downloadFileFromResponse = async (
  response: ApiResponse<Blob | string>
) =>
  download(
    response.body,
    getFileNameFromResponse(response),
    getMimeTypeFromResponse(response)
  )

export const download = (
  data: string | Blob,
  fileName: string,
  mimetype: string
) => {
  const url = URL.createObjectURL(
    data instanceof Blob
      ? data
      : new Blob([data], {
          type: mimetype,
        })
  )
  const a = document.createElement("a")
  a.style.display = "none"
  a.download = fileName
  a.href = url
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(url)
}
